module.exports = __webpack_public_path__ + "d833397fb038a8fbe9ec07b2884898d1-Shovel.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/assets/Shovel.jpg
// module id = 588
// module chunks = 0